import React from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import { FaMagic } from 'react-icons/fa';

const MessageLabel = ({ text, className, toolMessage, noMargin, handleAIModal, enableAI }) => {
    return (
        <div className="d-flex position-relative justify-content-between align-items-center">
            <p className={`${text?.length && className ? className : ""} ${!text?.length ? "labelLoader square " : ""} theme-text-color ${!noMargin ? "mb-3" : ""} admin-input-title d-block position-relative`.trim()}>
                {text}
            </p>
            {toolMessage &&
                <div className='tool-tip-open ms-2'>
                    <BsInfoCircle />
                    <p className='theme-text-color d-none tool-tip-text admin-input-title d-block position-absolute'>{toolMessage}</p>
                </div>
            }
            {enableAI &&
                <button
                    className="ms-2 theme-text-color button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3 position-relative overflow-hidden"
                    style={{
                        transition: "all 0.25s ease-in-out",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                    }}
                    onClick={handleAIModal}
                >
                    <span className="d-flex align-items-center gap-2 position-relative z-10">
                        <FaMagic className="text-warning" />
                        <span className="fw-medium">AI Suggestion</span>
                    </span>
                    <span
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            background: "linear-gradient(120deg, transparent, rgba(255,255,255,0.15), transparent)",
                            transform: "translateX(-100%)",
                            animation: "shimmer 2s infinite"
                        }}
                    />
                </button>
            }
        </div>
    );
};

export default MessageLabel;
